/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import {Component, OnInit} from '@angular/core';
import {FormControl,FormBuilder, FormGroup,FormArray,Validators, AbstractControl} from '@angular/forms';
import {UserlockService} from '../services/userlock.service';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';

@Component({
  selector: 'app-userlock',
  templateUrl: './userlock.component.html',
  styleUrls: ['./userlock.component.css']
})
export class UserlockComponent implements OnInit {
  success = false;
  error = false;
  data;

  errorMessage:string = "Server Error";
  language:string;
  public lang;
  public browserLang;
  doNotMatch = false;
  message;
  public users;
  public totalItems;
  public currentPage = 1;
  public pageNumber;
  public pageSize;
  public unlockId;
  public noData:boolean = false;

  public userSearchForm = new FormGroup({
    'employeeId': new FormControl('', Validators.required),
    'certificateNumber' : new FormControl('', Validators.required)
  });
  public employeeId: AbstractControl = this.userSearchForm.get('employeeId');
  public certificateNumber: AbstractControl = this.userSearchForm.get('certificateNumber');

  constructor(public userService:UserlockService,private translate:TranslateService) {
    this.lang = translate.currentLang;

    this.translate.onLangChange.subscribe((event:LangChangeEvent) => {
      this.browserLang = event.lang
      this.lang = this.browserLang;
    });
  }


  ngOnInit() {
    this.employeeId.patchValue('');
    this.certificateNumber.patchValue('');
    this.pageNumber = 1;
    this.pageSize = 10;
    this.getuser();
  }
  public getuser(){
    this.userService.getUser(this.employeeId.value,this.certificateNumber.value,this.pageNumber,this.pageSize)
      .subscribe(
        (response) => {
          this.error = false;
          this.noData = false;
          this.users = response['content'];
          if(response['content'].length == 0){
            this.noData = true;
          } else {
            this.noData = false;
          }
          this.totalItems = response['totalElements'];
        },
        (error) => {
          this.error = true;
        }
      );
  }
  unlockUser(unlockId) {
      this.error = false;
      this.success = false;
      this.userService.unlockUser(unlockId).subscribe(
        data => {
          this.data = data;
          if (this.data.status == 200) {
            this.error = null;
            this.success = true;
            this.message = this.data.message;
            this.pageNumber = 1;
            this.pageSize = 10;
            this.getuser();
          } else {
            this.success = null;
            this.error = true;
            this.message = this.data.message;
          }
        },
    error => this.errorMessage = <any>error);

  }
  public pageChanged(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.itemsPerPage;
    this.getuser();
  }
  public clearSearchData() {
    if (this.employeeId.value == '' || this.certificateNumber.value == ''){
      this.employeeId.patchValue('');
    this.certificateNumber.patchValue('');
    this.pageNumber = 1;
    this.pageSize = 10;
    this.getuser();
  }
  }

}
